const { TipsContainer } = require('./container/tipsContainer');
const { RankingContainer } = require('./container/rankingContainer');
const { SelectContainer } = require('./container/selectContainer');

export default { TipsContainer, RankingContainer, SelectContainer }